import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = ["href", "title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _directive_b_tooltip = _resolveDirective("b-tooltip");
  return _withDirectives((_openBlock(), _createElementBlock("a", {
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$emit('click');
    }),
    href: this.href,
    class: _normalizeClass([$options.btnClass, "btn btn-sm"]),
    title: $props.tooltip
  }, [_renderSlot(_ctx.$slots, "default")], 10 /* CLASS, PROPS */, _hoisted_1)), [[_directive_b_tooltip, void 0, void 0, {
    hover: true
  }]]);
}